<template>
	<form @submit.prevent="save">
		<vs-card class="flex flex-col justify-between p-5" fixedHeight style="min-height: 70vh">
			<ResponseAlert ref="response" />			
			<vs-row class="pt-5">
				<div class="w-full md:w-1/4 lg:w-2/12 mb-5 md:mb-0 md:pr-2">
					<img :src="getUrlOfFile(vars.image, true)" alt="image-profile" class="w-3/4 md:w-full block m-auto">
					<vs-button color="primary" type="border" icon="upload_file" class="w-full mt-3" @click="$refs.file_upload.click()">
						<span class="text-xs">Upload Photo</span>
					</vs-button>
					<input ref="file_upload" type="file" accept="image/png, image/gif, image/jpeg, image/jpg"
						v-on:change="AddPhoto" hidden />
				</div>
				<div class="w-full md:w-1/2 lg:w-5/12 md:px-3">
					<div class="w-full mb-5">
						<vs-input 
								autocomplete="off"
								v-validate="'required'" 
								label="Name" 
								name="name" 
								type="text"
								v-model="models.name" 
								class="w-full"/>
						<span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>
					</div>

					<div class="w-full my-5">
						<label class="pl-2 text-sm" for="status">Status</label>
						<ul id="status" class="flex mt-3">
							<li>
								<vs-radio v-model="models.isActive" vs-name="status" :vs-value="true" class="mr-5">Active</vs-radio>
							</li>
							<li>
								<vs-radio v-model="models.isActive" vs-name="status" :vs-value="false">Inactive</vs-radio>
							</li>
						</ul>
						<span class="text-danger text-sm" v-show="errors.has('status')">{{ errors.first('status') }}</span>
					</div>
				</div>
			</vs-row>

			<div slot="footer" class="justify-center">
				<vs-button button="submit" color="primary" type="filled" class="mr-3">Save</vs-button>
				<vs-button @click="$router.go(-1)" color="rgb(172,172,172)" type="border">Cancel</vs-button>
			</div>
		</vs-card>
	</form>
</template>

<script>
	import api from '@/utils/api.js'
	import {
		getUrlOfFile,
		uploadFile
	} from '@/utils/helpers.js';

	export default {
		name: 'FormSkinConcerns',
		data() {
			return {
				config: {
					uri: this.$route.meta.link,
				},
				models: {
					name: '',
					isActive: true,
					image: ''
				},
				vars: {
					image: ''
				},
				getUrlOfFile
			}
		},
		created() {
			this.getById();
		},
		methods: {
			getById() {
				if (this.$route.params.id) {
					this.vars.role_password = ''
					this.$axios.get(`${api.skinTypes}/${this.$route.params.id}`)
						.then(res => {
							const { data } = res.data;
							this.models.name = data.name;
							this.models.isActive = data.isActive;
							this.vars.image = data.image;
						}).catch(() => this.$router.push({
							name: 'page404'
						}));
				}
			},
			
			AddPhoto(event) {
				let fileSizeLimit = 1024 * 1024 * 2; // limit 2 MB
				if(event.target.files[0].size < fileSizeLimit) {
					this.vars.image = event.target.files[0];
				} else {
					this.$showToast('Failed', `Max file size is 2 MB`, 'danger')
				}
			},

			save() {
				this.$validator.validate().then(async valid => {
					if (valid) {
						let request = "";
						let message = "create"

						this.models.image = typeof this.vars.image === 'string' ? this.vars.image : await uploadFile(this.vars.image)

						if (!this.$route.params.id) {
							request = this.$axios.post(api.skinTypes, this.models);
						} else {
							message = "update"
							request = this.$axios.put(`${api.skinTypes}/${this.$route.params.id}`, this.models);
						}
						request
							.then(() => {
								this.$showToast('Success', `Success ${message} skin concern`,)
								this.$router.push({
									name: this.config.uri
								})
							})
							.catch(error => this.$refs.response.setResponse(error.response.data, 'danger'));
					} else {
						window.scrollTo(0, 0);
					}
				});
			}
		}
	}
</script>